import { combineReducers } from "redux";
import {
  authorization,
  profile,
  currentRoute,
  notifications,
  app,
  usersForm,
  users,
  alerts,
  alertsForm,
  currentTheme,
  typeeats,
  typeeatsForm,
  registers,
  registersForm,
} from "./Reducers";

export default combineReducers({
  registers,
  registersForm,
  typeeats,
  typeeatsForm,
  app,
  authorization,
  currentRoute,
  profile,
  notifications,
  usersForm,
  users,
  alerts,
  alertsForm,
  currentTheme,
});
